import { Box, Button } from '@mui/material';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonIcon } from '../common/CommonIcon';

interface VoiceModalListeningHintsDocsLinkProps {
  onOpenDocs: () => void;
}

export const VoiceModalListeningHintsDocsLink: FC<VoiceModalListeningHintsDocsLinkProps> = ({
  onOpenDocs,
}) => {
  const { t } = useTranslation();
  return <Box sx={{ pt: 0.5, display: 'flex', justifyContent: 'center' }}>
    <Button
      variant="text"
      size="small"
      onClick={onOpenDocs}
      disableRipple
      sx={{
        color: 'var(--tg-theme-text-color)',
        textTransform: 'none',
        fontWeight: 600,
        fontSize: 12,
        minWidth: 0,
        px: 1.25,
        py: 0.5,
        gap: 0.5,
        opacity: 0.95,
      }}
    >
      {t('voice.allCommands')}
      <CommonIcon
        icon="arrow_forward"
        type="filled"
        size={14}
        color="var(--tg-theme-text-color)"
      />
    </Button>
  </Box>;
};
